<script setup lang="ts">
const benefits = [
  {
    title: 'Visi Perusahaan',
    description:
      'Mempermudah pebisnis dalam mengelola kebutuhan pengiriman bisnisnya, sehingga, bisnis mereka dapat tumbuh lebih efisien dan juga berkelanjutan.',
    icon: 'material-symbols:arrow-outward',
    iconSize: '33px'
  },
  {
    title: 'Misi Kami',
    description:
      'Melakukan peningkatan kualitas pengiriman suatu bisnis melalui inovasi teknologi.',
    icon: 'material-symbols:rocket-launch-outline',
    iconSize: '33px'
  }
]
</script>

<template>
  <section class="bg-surface-container-low py-16 lg:py-24">
    <UiContainer class="py-5 flex flex-col gap-6 lg:gap-16">
      <h2
        class="text-2xl leading-7 lg:text-4xl font-bold lg:text-center text-on-secondary-container font-display"
      >
        Kenapa Harus Memilih <span class="text-primary">KiriminAja</span>
      </h2>
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <UiCardFeature
          v-for="(benefit, index) in benefits"
          :key="index"
          :icon="benefit.icon"
          :icon-size="benefit.iconSize"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>

      <CtaBase />
    </UiContainer>
  </section>
</template>
